import React, { useState, useContext } from 'react'
import reduce from 'lodash/reduce'
import PropTypes from 'prop-types'
import Cart from '../Cart'
import { Link } from 'gatsby'
import StoreContext from '../../context/StoreContext'
import ExternalLink from '../externalLink'
import styled from 'styled-components'
import CartIcon from './cartIcon'

const HeaderWrapper = styled.div`
  margin-bottom: 1.45rem;
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 35px;
  align-items: center;
  padding: 1em 0;
  grid-gap: 1em;
  margin: 0 auto;
  max-width: 1400px;
  @media screen and (max-width: 1000px) {
    grid-template-columns: auto 45px 40px;
  }
  @media screen and (max-width: 700px) {
    grid-template-columns: auto 50px 55px;
  }
`

const NavigationLinks = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 125px auto  82px;
  text-transform: uppercase;
  justify-content: end;
  grid-gap: 2em;
  @media screen and (max-width: 1000px) {
    display:block;
    justify-items: center;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background-color: white;
    z-index: 999;
    padding: 5em 1em;
    transition: transform 300ms;
    transform: ${({ mobnav }) =>
      mobnav ? 'translateY(0%)' : 'translateY(-100%)'};
    div {
      margin-top: 1em;
    }
  }
`

const CartButton = styled.div`
  text-decoration: none;
  font-size: 2rem;
  cursor: pointer;
  font-weight: bold;
  svg {
    margin-right: 4px;
  }
`

const CartCounter = styled.span`
  background-color: white;
  color: #000;
  border-radius: 20px;
  padding: 1px 5px;
  font-size: 10px;
  float: right;
  margin: -44px -5px;
  z-index: 20;
  border: 1px solid;
  padding-bottom: 0px;
`


const LogoLink = styled.div`
  text-decoration: none;
  font-size: 1em;
  text-transform:uppercase;
`

const MobileNav = styled.button`
  display: none;
  @media screen and (max-width: 1000px) {
    display: grid;
    text-decoration: none;
    font-size: 2rem;
    cursor: pointer;
    background: none;
    outline: none;
    justify-self: left;
    border: none;
    right: -9px;
    position: relative;
    top: -4px;
    div {
      width: 1.8rem;
      height: 1px;
      margin: 7px 0;
      background: black;
      transform-origin: 1px;
      position: relative;
      z-index:10000;
      transition: transform 300ms;
      :first-child {
        transform: ${({ mobnav }) => (mobnav ? 'rotate(41deg)' : 'rotate(0)')};
      }
      :nth-child(2) {
        transform: ${({ mobnav }) => (mobnav ? 'rotate(-45deg)' : 'rotate(0)')};
        margin: ${({ mobnav }) => (mobnav ? '12px 0' : '0')};
      }
    }
  }
`

const NavContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 30%;
  height: 100vh;
  min-width: 300px;
  background-color: white;
  z-index: 999;
  padding: 5em 1em;
  transition: transform 300ms;
  transform: ${({ nav }) => (nav ? 'translateX(0%)' : 'translateX(100%)')};
  overflow-y:scroll;
  button {
    background: none;
    cursor: pointer;
    border: 1px solid;
  }
`


const NavigationBar = styled.button`
  color: black;
  text-decoration: none;
  font-size: 2rem;
  cursor: pointer;
  background: none;
  outline: none;
  justify-self: left;
  border: none;
  div {
    width: 2.3rem;
    transform-origin: 1px;
    position: relative;
    transition: transform 300ms;
  }
`

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)
  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

const Navigation = ({ siteTitle }) => {
  const {
    toggleCart,
  } = useContext(StoreContext)
  const [hasItems, quantity] = useQuantity()
  const [nav, showNav] = useState(false)
  const [mobnav, showMobile] = useState(false)



  function closeMobile() {
    showMobile(false)
  }

  return (
    <HeaderWrapper>
      <Container>
        <LogoLink>
          <Link to="/">{siteTitle}</Link>
        </LogoLink>

        <MobileNav mobnav={mobnav} onClick={() => showMobile(!mobnav)} aria-label="Mobile Navigation Button">
          <div />
          <div />
        </MobileNav>

        <NavigationLinks mobnav={mobnav}>
         
          <div>
            <Link onClick={closeMobile}  to="/personal">Personal</Link>
          </div>
          <div>
            <Link onClick={closeMobile}  to="/client">Client</Link>
          </div>
          <div>
            <Link onClick={closeMobile}  to="/film">Film</Link>
          </div>
          <div>
            <Link onClick={closeMobile}  to="/building-a-ladder">Building a Ladder</Link>
          </div>

          <div>
            <Link onClick={closeMobile} to="/shop">Shop</Link>
          </div>

          <div>
            <a href="mailto:ellingtonhammond@me.com" target="_blank" rel="noopener noreferrer" >
              Contact <ExternalLink />
            </a>
          </div>
        </NavigationLinks>

        <NavigationBar aria-label="cart"  onClick={toggleCart}>
          <CartButton>
            <CartIcon />
            {hasItems && <CartCounter>{quantity}</CartCounter>}
          </CartButton>
        </NavigationBar>

        <NavContainer nav={nav}>
          <button onClick={() => showNav(!nav)}> x close</button>
          <Cart />
        </NavContainer>
      </Container>
    </HeaderWrapper>
  )
}

Navigation.propTypes = {
  siteTitle: PropTypes.string,
}

Navigation.defaultProps = {
  siteTitle: ``,
}

export default Navigation